import { render, staticRenderFns } from "./PatientTransferRequest.html?vue&type=template&id=a3f19076&"
import script from "./PatientTransferRequest.js?vue&type=script&lang=js&"
export * from "./PatientTransferRequest.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports